import React, { useState, useEffect , useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import {useReactToPrint} from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';


function DigitMaster(props) {
  const [rooms, setRooms] = useState([]);
  const [Number, setNumber] = useState(0);
  const [Character, setCharacter] = useState('')

  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [formMode, setFormMode] = useState('add');
  const [editRoomId, setEditRoomId] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [DigitMasterEntries, setDigitMasterEntries] = useState([]);

  useEffect(() => {
    fetchDigitMaster();
  }, []);

  const fetchDigitMaster = async () =>{
    try{
      const response = await axios.get('https://www.wingap.net.in/api/digit');
      setDigitMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1;
      setNumber(nextEntryNo)
      //console.log(response)
    }catch(error){
      console.log('error:', error);
    }
  };

  const calculateMaxEntryNo = (entries) => {
    let maxEntryNo = 0;
    for (const entry of entries) {
      if (entry.Number > maxEntryNo) {
        maxEntryNo = entry.Number;
      }
    }
    return maxEntryNo;
  };



  const addDigit = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/digit', {
        Number:  Number,
        Character: Character,
        USERID: props.name
      });
      fetchDigitMaster();
      setNumber('');
      setCharacter('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateRoom = async (Number) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/digit/${Number}`, {
        Number:  Number,
        Character: Character,
        USERID: props.name
      });
      fetchDigitMaster();
      setNumber('');
      setCharacter('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };
  

  const deleteRoom = async (Number) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/digit/${Number}`, {
        headers: {
          'username': props.name,
        },
      });
      if (response.status === 200) {
        fetchDigitMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  };

  const setEditForm = (room) => {
    setFormMode('edit');
    setNumber(room.Number);
    setCharacter(room.Character);
    setShowGrid(false);
  };

 
 /*  const handleSearch = (searchQuery) => {
    const filtered = rooms.filter((room) => {
      // Convert room.RoomNo, room.deptName, etc., to strings before using includes
      const deptCode = room.DeptCode.toString().toLowerCase();
      const deptName = room.deptName.toString().toLowerCase();
      const deptNameENG = room.deptNameENG.toString().toLowerCase();
      const compCode = room.compCode.toString().toLowerCase();
      const flag = room.flag.toString().toLowerCase();

      // Check if any of the properties contain the searchQuery (converted to lowercase)
      return (
        deptCode.includes(searchQuery.toLowerCase()) ||
        deptName.includes(searchQuery.toLowerCase()) ||
        deptNameENG.includes(searchQuery.toLowerCase()) ||
        compCode.includes(searchQuery.toLowerCase()) ||
        flag.includes(searchQuery.toLowerCase())
      );
    });

    // Update the deptMasterEntries state with the filtered results
    setDeptMasterEntries(filtered);
  }; 

  // ... Rest of your code ...

  // Update the filtered rooms based on the searchQuery prop
  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, rooms]);*/

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setRooms(rooms); 
  }

  const handleCancel = () => {
    setFormMode('add');
    setEditRoomId('');
    setNumber('');
    setCharacter('');
    fetchDigitMaster();
  }

   
  const componentPDF= useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "Year Master Data",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (

    <div style={{ maxWidth: '100%', margin: '0 auto',padding: '20px' }} >
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Digit Master</h1>
      <Grid item>
          <Button
            variant="contained"
            className="view-button"
            onClick={handleshowandhide}
            sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float:'right'}}
          >
            {showGrid ? 'Add' : 'Back'}
          </Button>
        </Grid>
        {showGrid && <Grid item>
          <Button
            variant="contained"
            onClick={generatePDF}
            sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float:'right', marginRight:"10px"}}
          >
            Download PDF
          </Button>
        </Grid>}
        {showGrid && <Grid item>
          <Button
            variant="contained"
            // onClick={generatePDF}
            sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float:'right', marginRight:"10px"}}
          >
            Export
          </Button>
        </Grid>}
        {!showGrid && (
           <>
           <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
           <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="Number" style={{ width: '150px', marginRight: '10px' }}>Number</label>
               <input
                 type="text"
                 value={Number}
                 readOnly
                 placeholder="Number"
                 style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="Character" style={{ width: '150px', marginRight: '10px' }}>Character</label>
               <input
                 type="text"
                 value={Character}
                 onChange={(e) => setCharacter(e.target.value)}
                 placeholder="Character"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             </div>
           <div>
             <button
               className={formMode === 'add' ? 'add-button' : 'update-button'}
               onClick={formMode === 'add' ? addDigit : () => updateRoom(Number)}
               style={{
                 padding: '10px 20px',
                 fontSize: '16px',
                 backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
                 color: 'white',
                 border: 'none',
                 cursor: 'pointer',
                 marginBottom: '10px',
               }}
             >
               {formMode === 'add' ? 'Add' : 'Update'}
             </button>
             <button
               className="view-button"
               onClick={handleCancel}
               style={{
                 padding: '10px 20px',
                 fontSize: '16px',
                 backgroundColor: '#f44336',
                 color: 'white',
                 border: 'none',
                 cursor: 'pointer',
                 marginLeft: '10px',
                 marginBottom: '10px',
               }}
             >
               Cancel
             </button>
           </div>
         </>
         
          )}
        {showGrid && (
            <div ref={componentPDF} style={{width:'100%'}}>
              <h2>Entries</h2>
              <table
                style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  border: '1px solid #ccc',
                }}
              >
                <thead>
                  <tr style={{ background: '#f2f2f2', color:'black' }}>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      Number
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                     Character
                    </th>
                    
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {DigitMasterEntries.map((room) => (
                    <tr key={room.Number} style={{backgroundColor:'white', color:'black', textAlign:'center'}}>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.Number}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.Character}</td>
                      <td className="print-hide" >
                        <button
                          style={{
                            padding: '5px 10px',
                            backgroundColor: 'rgb(76, 175, 80)',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            marginRight: '5px',
                            marginLeft:'10px',
                          }}
                          onClick={() => setEditForm(room)}
                        >
                          Edit
                        </button>
                        <button
                          style={{
                            padding: '5px 10px',
                            backgroundColor: 'rgb(244, 67, 54)',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                          }}
                          onClick={() => deleteRoom(room.Number)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{ fontSize: '16px' }} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>


    </div>
  );
}

export default DigitMaster;